<template>
  <div class="col-12 col-lg-8 mx-auto">
    <img
      v-if="errorImage"
      :src="url"
      width="300"
      height="300"
      class="rounded mx-auto my-4 d-block"
    >
    <div
      class="d-flex justify-content-center text-blue-200 font-weight-bold"
      style="font-size:80px"
    >
      {{ code }}
    </div>
    <div class="my-4">
      <div class="h4 font-weight-bold text-center">
        Allo Houston, nous avons un problème...
      </div>
      <div class="text-secondary text-center">
        {{ message }}
      </div>
    </div>
    <div class="my-4 text-center">
      <button
        type="button"
        class="btn btn-blue-500 btn-block mb-3 me-3"
        style="text-decoration: none"
        @click="openIntercom"
      >
        Se faire rappeler
      </button>
      <button
        type="button"
        class="btn btn-secondary btn-block mb-3"
        style="text-decoration: none"
        @click="rt_previous"
      >
        <font-awesome-icon
          icon="long-arrow-alt-left"
          class="mr-2"
        />
        Retour au site
      </button>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { routing } from '@/mixins';
import errorMap from '@/assets/data/errorMap.json';

export default {
  name: 'ErrorView',
  mixins: [routing],
  data() {
    return {
      url: '',
      message: '',
      code: '',
    };
  },
  computed: {
    errorImage: () => import.meta.env.NODE_ENV !== 'production',
  },
  created() {
    const { name } = this.$route.params;
    const error = errorMap[name] || {};
    const defaultError = {
      code: 404,
      message: `Il semblerait que la page visitée n'existe plus,
        nous vous invitons à réessayer ultérieurement`,
    };
    this.code = error.code || defaultError.code;
    this.message = error.message || defaultError.message;
    this.$store.dispatch('reporting/sendInfo', { err: new Error(this.code), currentPage: 'ErrorInfo' });
  },
  beforeMount() {
    if (this.errorImage) {
      const url = 'https://api.giphy.com/v1/gifs/random?api_key=6viPkswOM1a286ZTiG00ogeYYF1NbVFZ&tag=error';
      const httpRequest = new XMLHttpRequest();
      httpRequest.onreadystatechange = (data) => {
        try {
          if (data.target.status === 200) {
            const response = JSON.parse(data.target.response);
            this.url = response.data.image_url;
          }
        } catch (err) { this.$store.dispatch('reporting/sendInfo', err) }
      };
      httpRequest.open('GET', url);
      httpRequest.send();
    }
  },
  methods: {
    ...mapActions({
      openIntercom: 'intercom/openMessenger',
    }),
  },
};
</script>
